class RetailPriceListController {
  constructor(authService, appConfig, loadingService) {
    "ngInject";

    if(!authService.authData.isAdmin) { return; }

    this.loadingService = loadingService;
    this.uploadUrl = appConfig.apiServiceBaseUri + 'api/file/uploadRetailPriceList';

    this.notification = {
      type: '',
      msg: ''
    }
  }

  showUploading() {
    const ctrl = this;

    this.notification = {
      type: '',
      msg: ''
    }

    ctrl.loadingService.showLoading('retailPriceListUpload', 'Uploading Media Item(s)');
  }

  showError(response) {
    const ctrl = this;

    if (response.status === 500) {
      ctrl.notification = {
        type: 'error',
        msg: response.data.exceptionMessage
      };
    }
    else {
      ctrl.notification = {
        type: 'error',
        msg: 'Something went wront'
      };
    }

    ctrl.loadingService.hideLoading('retailPriceListUpload', 'Uploading Media Item(s)');
  }

  onCsvUploadSuccess(response) {
    const ctrl = this;
    ctrl.retailPriceList = response.data;

    ctrl.notification = {
      type: 'success',
      msg: 'Retail Price List updated successfully'
    };

    ctrl.loadingService.hideLoading('retailPriceListUpload', 'Uploading Media Item(s)');
  }

}

export default RetailPriceListController;



// WEBPACK FOOTER //
// ./client/app/components/admin/retailPriceList/retailPriceList.controller.js